.logo {
  /* width: 10%; */
  object-fit: contain;
}

.loginLogoContainer {
  padding: 3rem;
}

.loginLogo {
  height: 4.5rem;
  object-fit: contain;
}

.welcome {
  position: absolute;
  top: 10vh;
  height: fit-content;
}

.layout {
  display: grid;
  height: 100vh;
  overflow: hidden;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 0.1fr 0.2fr 3fr;
  grid-template-areas:
    'sidebar sidebar sidebar sidebar sidebar sidebar'
    'main main main main main main'
    'main main main main main main';
}

.layoutPromotion {
  display: grid;
  height: 100vh;
  overflow: hidden;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 0.1fr 0.2fr 3fr;
  grid-template-areas:
    'promo promo promo promo promo promo'
    'sidebar sidebar sidebar sidebar sidebar sidebar'
    /* 'nav nav nav nav nav nav' */
    'main main main main main main';
}

.sidebarBig {
  display: flex;
  height: 4.4rem;
  /* left: 0; */
  /* right: 0; */
  padding: 0.5rem;
  padding-right: 1.5rem;
  border-bottom: 1px solid #e1e1e1;
  flex-direction: row;
  justify-content: space-between;
  grid-area: sidebar;
  background-color: var(--sidebar-bg-color);
}

.sidebarSmall {
  display: none;
  background-color: var(--sidebar-bg-color);
}

.loginTopBar {
  background-color: var(--sidebar-bg-color);
}

.nav {
  /* Subtracting sidebarBig's height */
  height: calc(100vh - 4.4rem);
  grid-area: nav;
}

.promoNavBar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.6rem 1.5rem;
  background-color: var(--promo-bg-color);
  grid-area: promo;
}

.promoNavBar:hover {
  cursor: pointer;
}

.main {
  /* Required to make sidebar stick */
  overflow: auto;
  grid-area: main;
  background-color: var(--main-bg-color);
}

.content {
  min-height: 85vh;
}

.additionalNavLinks {
  /* border-top: 0.8px solid hsl(0, 0%, 60%); */
  display: flex;
  flex-direction: row;
  gap: 0.3rem;
  /* padding-top: 0.3rem; */
}

.additionalNavLinkBtn {
  display: flex;
  align-items: center;
  width: 100%;
}

.selectedNav {
  color: var(--navbar-selected-button-text-color) !important;
}

ion-icon {
  font-size: 1.25rem;
  color: #999999;
  padding-right: 0.5rem;
}

ion-icon:hover {
  color: var(--navbar-selected-button-text-color);
}

@media only screen and (max-width: 550px) {
  .layout {
    grid-template-columns: 1fr;
    grid-template-rows: 0.2fr auto 0.3fr;
    grid-template-areas:
      'nav'
      'main'
      'sidebarSmall';
  }

  .layoutPromotion {
    grid-template-columns: 1fr;
    grid-template-rows: 0.2fr 0.2fr auto 0.3fr;
    grid-template-areas:
      'promo'
      'nav'
      'main'
      'sidebarSmall';
  }

  .sidebarBig {
    display: none;
  }

  /* TODO Beautify Mobile view */
  .sidebarSmall {
    display: flex;
    height: 9vh;
    grid-area: sidebarSmall;
  }
}
